<template>
  <div class="tw-mb-4">
    <WdsStack gap-md justify-start align-center>
      <div class="tw-max-w-[300px]">
        <WdsSelect
          v-if="teamMembers.length"
          v-model="selectedOwnerObjects"
          multi-select
          can-deselect
          searchable
          :list="teamMemberOptions"
          :placeholder="$t('Select owners')"
          @load-more="handleLoadMoreOwners"
        />
      </div>

      <div class="tw-mr-2 tw-max-w-[150px]">
        <WdsSelect
          class="tw-min-w-[130px]"
          :list="statusOptions"
          :start-selected="selectedStatusFilter"
          :placeholder="$t('Select status')"
          @select-option="updateStatusFilter"
        />
      </div>

      <a href="#" class="tw-block tw-ml-3 tw-text-sm" @click="resetFilters">
        {{ $t('Reset filters') }}
        <i :class="{ loading: isResetting }" class="fa fa-undo" />
      </a>
    </WdsStack>
  </div>
</template>

<script>
import { WdsSelect, WdsStack } from '@worksome/wds-components'
import { LocalStorageEncoder } from '@/utils/Encoders'

export default {
  components: {
    WdsSelect,
    WdsStack,
  },

  props: {
    teamMembers: {
      type: Array,
      default: () => [],
    },
  },

  emits: ['loadMoreOwners', 'filters-updated'],

  data() {
    return {
      isResetting: false,

      statusOptions: [
        { value: 'ALL', label: this.$t('All projects') },
        { value: 'OPEN', label: this.$t('Active projects') },
        { value: 'ENDED', label: this.$t('Ended projects') },
      ],

      selectedStatuses: [],
      selectedStatusFilter: 'ALL',

      selectedOwnerIds: new LocalStorageEncoder({
        storageKey: 'owners',
        decoder: (data) => data?.split(',').filter((val) => val !== '') || [],
        defaultVal: [],
      }),
    }
  },

  computed: {
    filter() {
      return {
        owners: this.selectedOwnerIds.data.filter(
          (globalId) =>
            this.teamMemberOptions.map((teamMember) => teamMember.value).includes(globalId) ||
            this.teamMemberOptions.length === 0,
        ),
        status: this.selectedStatuses,
      }
    },

    selectedOwnerObjects: {
      get() {
        return this.teamMemberOptions.filter((teamMember) =>
          this.selectedOwnerIds.data.includes(teamMember.value),
        )
      },
      set(newValue) {
        this.selectedOwnerIds.data = newValue.map((selectedOwner) => selectedOwner.value)
      },
    },

    teamMemberOptions() {
      let list = []
      if (this.teamMembers.length) {
        list = this.teamMembers.map((teamMember) => ({
          value: teamMember.id,
          label: teamMember.name,
        }))
      }
      return list.length ? list : []
    },
  },

  watch: {
    filter: {
      immediate: true,
      deep: true,
      handler(newVal) {
        this.$emit('filters-updated', newVal)
      },
    },
  },

  methods: {
    handleLoadMoreOwners() {
      this.$emit('loadMoreOwners')
    },

    updateStatusFilter(selected) {
      if (selected.value === 'ALL') {
        this.selectedStatuses = []
      } else {
        this.selectedStatuses = [selected.value]
      }
      this.selectedStatusFilter = selected
    },

    resetFilters() {
      this.isResetting = true
      setTimeout(() => {
        this.isResetting = false
      }, 600)
      this.selectedOwnerIds.data = []
      this.selectedStatusFilter = 'ALL'
    },
  },
}
</script>

<style scoped>
@keyframes rotation {
  from {
    -webkit-transform: rotate(359deg);
  }
  to {
    -webkit-transform: rotate(0deg);
  }
}

.fa-undo.loading {
  animation: rotation 0.3s 1 ease-out;
  -webkit-animation: rotation 0.3s 1 ease-out;
}
</style>
